import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Table } from "antd";
import { routeToAddOrEdit } from "../../utils";
import UsefulFunctions from "../../utils/UsefulFunctions";
/* Хүснэгт зурах */
function AntdTable({
  dataSource,
  columns,
  url,
  pagination,
  isDoubleClick,
  model,
  method,
  isPagination,
  request,
  isModal,
  isSelectRow,
  selectedRows,
  isBranch,
}) {
  const [selectedRow, setSelectedRow] = useState({});
  const defaultPagination = JSON.parse(
    localStorage.getItem(`pagination${url}`)
  );
  const navigate = useNavigate();
  const params = useParams();

  const sendRequest = (a, b) => {
    if (isPagination) {
      let values = JSON.parse(localStorage.getItem(`search${url}`));
      request({
        url,
        method,
        model,
        body: {
          ...values,
          pagenumber: a,
          count: b,
        },
      });
    }
  };

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const onSelectChange = (newSelectedRowKeys) => {
    if (selectedRows) selectedRows.current = newSelectedRowKeys;
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    selections: [
      Table.SELECTION_INVERT,
      {
        key: "odd",
        text: "Сондгой мөрүүдийг сонгох",
        onSelect: (changableRowKeys) => {
          let newSelectedRowKeys = [];
          newSelectedRowKeys = changableRowKeys.filter((_, index) => {
            if (index % 2 !== 0) {
              return false;
            }
            return true;
          });
          setSelectedRowKeys(newSelectedRowKeys);
        },
      },
      {
        key: "even",
        text: "Тэгш мөрүүдийг сонгох",
        onSelect: (changableRowKeys) => {
          let newSelectedRowKeys = [];
          newSelectedRowKeys = changableRowKeys.filter((_, index) => {
            if (index % 2 !== 0) {
              return true;
            }
            return false;
          });
          setSelectedRowKeys(newSelectedRowKeys);
        },
      },
    ],
  };

  return (
    <Table
      dataSource={isPagination ? dataSource.data : dataSource}
      rowSelection={isSelectRow ? rowSelection : null}
      columns={columns}
      size="small"
      rowKey={(row) => row.id}
      scroll={
        !isModal ? { x: "80vw", y: "25rem" } : isBranch ? { y: 350 } : null
      }
      rowClassName={(record, rowIndex) => {
        return rowIndex === selectedRow.rowIndex ? "selected-row" : "";
      }}
      pagination={
        pagination
          ? {
              defaultPageSize: defaultPagination
                ? defaultPagination.defaultPageSize
                : 10,
              defaultCurrent: defaultPagination
                ? defaultPagination.defaultCurrent
                : 1,
              total: isPagination
                ? dataSource.count
                : dataSource && dataSource.length,
              showSizeChanger: true,
              onChange: (a, b, c) => {
                sendRequest(a - 1, b);
                localStorage.setItem(
                  `pagination${url}`,
                  JSON.stringify({ defaultCurrent: a, defaultPageSize: b })
                );
              },
              pageSizeOptions: [
                "10",
                "20",
                "30",
                "40",
                `${
                  isPagination
                    ? dataSource.count
                    : dataSource && dataSource.length
                }`,
              ],
            }
          : pagination
      }
      summary={(pageData) => (
        <Table.Summary fixed style={{ background: "#fafafa" }}>
          {isPagination ? (
            UsefulFunctions.renderSummaryRow({
              footer: dataSource && dataSource.footer,
              columns,
              isPagination,
            })
          ) : (
            <Table.Summary.Row>
              {UsefulFunctions.renderSummary({
                data: pageData,
                columns,
                isPagination,
              })}
            </Table.Summary.Row>
          )}
        </Table.Summary>
      )}
      onRow={(record, rowIndex) => {
        return {
          /*  onClick: (event) => {
            if (selectedRow && selectedRow.rowIndex === rowIndex) setSelectedRow({});
            else setSelectedRow({ ...record, rowIndex });
          }, */
          onDoubleClick: () => {
            if (isDoubleClick) {
              routeToAddOrEdit({ navigate, params, index: rowIndex, record });
            }
          },
        };
      }}
      bordered
      className="max-h-full sm:mt-4 xl:mt-0"
    />
  );
}

export default AntdTable;
